<template>
  <div>
    <div class="card mg-b-20">
      <div
        class="card-header d-flex align-items-center justify-content-between"
      >
        <h6 class="mg-b-0">{{ b != undefined ? b.nm : "Лайв сургалт" }}</h6>
      </div>
      <ul class="list-group list-group-flush">
        <li
          @click="activeMode(t) == -1 ? '' : $emit('on-detail', t)"
          class="list-group-item list-group-item-action d-flex align-items-center bd-0"
          v-for="(t, i) in tasks"
          :key="i"
          role="button"
        >
          <div class="d-flex">
            <!-- <div class="avatar">
              <span :class="`avatar-initial rounded-circle bg-transparent bd bd-gray-900`">
                <feather type="video" class="tx-color-02" style="margin-top: -4px; width: 19px; height: 19px;"></feather>
              </span>
            </div> -->
            <div class="avatar d-none d-sm-block">
              <span
                v-if="activeMode(t) == 0"
                :class="`avatar-initial rounded-circle bg-info`"
              >
                <i class="icon ion-md-time"></i>
              </span>
              <span
                v-else-if="activeMode(t) == 1"
                :class="`avatar-initial rounded-circle bg-warning`"
              >
                <i class="icon ion-md-open"></i>
              </span>
              <span
                v-else-if="activeMode(t) == -1"
                :class="`avatar-initial rounded-circle bg-gray-400`"
              >
                <i class="icon ion-md-checkmark"></i>
              </span>
            </div>
            <div class="pd-l-10">
              <h6 class="tx-14 tx-semibold mg-b-5">{{ t.task }}</h6>
              <div class="text-center tx-11 tx-color-03">
                <span v-if="activeMode(t) == 0">
                  <vue-countdown
                    :time="getSeconds(t.dueStartDate)"
                    v-slot="{ days, hours, minutes, seconds }"
                  >
                    {{ days }}х:{{ hours }}ц:{{ minutes }}м:{{ seconds }}с
                  </vue-countdown>
                </span>
                <span v-else-if="activeMode(t) == 1">
                  <vue-countdown
                    :time="getSeconds(t.dueDate)"
                    v-slot="{ days, hours, minutes, seconds }"
                  >
                    {{ days }}х:{{ hours }}ц:{{ minutes }}м:{{ seconds }}с
                  </vue-countdown>
                </span>
                <div v-else-if="activeMode(t) == -1">
                  {{ t.dueStartDate | moment("YYYY.MM.DD HH:mm") }} -
                  {{ t.dueDate | moment("YYYY.MM.DD HH:mm") }}
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-xs btn-outline-light mg-l-auto">
            <span v-if="activeMode(t) == 0">
              Удахгүй эхлэх
            </span>
            <span v-else-if="activeMode(t) == 1">
              Яг одоо үргэлжилж байна
            </span>
            <span v-else-if="activeMode(t) == -1">
              Дууссан
            </span>
          </button>
        </li>
      </ul>
    </div>
    <!--  -->
  </div>
  <!-- <div class="row row-xs">
    <div class="col-6 col-sm-4 col-md-3 col-lg-3 col-xl-3 col-xxl-3" v-for="(t,i) in tasks" :key="i">
        <div class="card">
          <div class="pd-20 pos-relative" :class="{'bg-danger': activeMode(t)==1, 'bg-success': activeMode(t)==-1, 'bg-primary': activeMode(t)==0 }">
            <a v-if="activeMode(t)==0" @click="$emit('on-detail', t)" class="btn btn-outline-info btn-xs pos-absolute r-10 t-10 text-white">
              <feather type="clock" class="mg-r-5"></feather>
              Эхлээгүй
            </a>
            <a v-else-if="activeMode(t)==1" @click="$emit('on-detail', t)" class="btn btn-outline-warning btn-xs pos-absolute r-10 t-10 text-white">
              <feather type="wifi" class="mg-r-5"></feather>
              LIVE
            </a>
            <a v-else-if="activeMode(t)==-1" class="btn btn-outline-light btn-xs pos-absolute r-10 t-10 text-white">
              <feather type="check" class="mg-r-5"></feather>
              Дууссан
            </a>

            <div class="text-center mg-t-40 mg-b-10 text-white tx-13">
              <span v-if="activeMode(t)==0">
                <div>эхлэхэд</div>
                <vue-countdown :time="getSeconds(t.dueStartDate)" v-slot="{ days, hours, minutes, seconds }">
                  {{days}}х:{{ hours }}ц:{{ minutes }}м:{{ seconds }}с
                </vue-countdown>
              </span>
              <span v-else-if="activeMode(t)==1">
                <div>Яг одоо үргэлжилж байна</div>
                <vue-countdown :time="getSeconds(t.dueDate)" v-slot="{ days, hours, minutes, seconds }">
                  {{days}}х:{{ hours }}ц:{{ minutes }}м:{{ seconds }}с
                </vue-countdown>
              </span>
              <div v-else-if="activeMode(t)==-1">
                <div>Дууссан</div>
                <div>{{t.dueStartDate | moment('MM.DD HH:mm')}} - {{t.dueDate | moment('MM.DD HH:mm')}}</div>
              </div>
            </div>
          </div>
          <div class="card-body tx-13">
            <div>
              <h6><a>{{t.task}}</a></h6>
              <button v-if="activeMode(t)==-1" class="btn btn-block btn-white btn-xs" disabled>дууссан</button>
              <button v-else @click="$emit('on-detail', t)" class="btn btn-block btn-primary btn-xs">оролцох</button>
            </div>
          </div>
        </div>

    </div>
    
  </div> -->
</template>

<script>
const moment = require("moment");
import VueCountdown from "@chenfengyuan/vue-countdown";

export default {
  components: {
    VueCountdown
  },
  props: {
    tasks: {
      type: Array,
      default: () => []
    },
    course: {
      type: Object,
      default: () => {}
    },
    b: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    //console.log(this.course);
  },
  methods: {
    activeMode(t) {
      if (moment(t.dueDate).isBefore(moment(this.course.date.now))) {
        //# past
        return -1;
      } else if (
        moment(t.dueStartDate).isBefore(moment(this.course.date.now)) &&
        moment(t.dueDate).isAfter(moment(this.course.date.now))
      ) {
        //# LIVE
        return 1;
      } else if (moment(t.dueStartDate).isAfter(moment(this.course.date.now))) {
        //# FUTURE
        return 0;
      }
    },
    getSeconds(d) {
      let _range =
        new Date(d).getTime() - new Date(this.course.date.now).getTime();
      return _range;
    }
  }
};
</script>

<style></style>
